import { enumSchema } from "vue-utils"

export enum MarriageType {
	Regular = "Regular",
	P87 = "P87",
}

export const MarriageTypeSchema = enumSchema(MarriageType)
